import React from "react";
import MaterialIcon from "../components/BuilderComponents/MaterialIcon";

const BuilderRightSideBar = ({
  isOpen,
  children,
  onClose,
  heading,
  style = {},
  size = "small",
  bodyClass,
  headerClass,
  containerClass
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`sidebarView_edit_outer edit_open ${size} ${containerClass}`}
      style={{ ...style }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`sidebar_top_header ${headerClass}`} style={{ padding: "16px" }}>
        <h4
          style={{
            maxWidth: "460px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {heading}
        </h4>
        <MaterialIcon
          name="close"
          className="section_close_darkIcon"
          onClick={(e) => {
            e.stopPropagation();
            onClose(false);
          }}
        />
      </div>
      <div className={`rightsidebar_body ${bodyClass}`}>{children}</div>
    </div>
  );
};

export default BuilderRightSideBar;
